import { app } from '../../../core/App';
import { Sounds } from '../../../sounds';
import { SpineEvents } from '../../../core/enums/SpineEvents';
import { EquipmentType } from '../VehicleEquipment';
import { VehicleEquipmentCapture } from '../VehicleEquipmentCapture';
import { VehicleVillain } from '../VehicleVillain';
import { VehicleHero } from './../VehicleHero';

export class VehicleCaptureCrane extends VehicleEquipmentCapture {
  public static animationEvents = {
    StartCrane: 'start-crane',
    StopCrane: 'stop-crane'
  } as const;

  protected fireYPos: number;
  protected fireDistance: number;
  protected prefireTime: number;
  protected beforeHitTime: number;
  protected fireTime: number;

  constructor(scene: Phaser.Scene, vehicle: VehicleHero) {
    super(scene, EquipmentType.Crane, vehicle);

    this.fireYPos = 0;
    this.fireDistance = 1000;
    this.prefireTime = 4000;
    this.beforeHitTime = 500;
    this.fireTime = 1000;

    this.vehicle.CharacterSpine.on(SpineEvents.Event, this.animationEvent, this);
    this.scene.events.once(Phaser.Scenes.Events.SHUTDOWN, this.cleanUp, this);
  }

  public beforeMoveIntoPosition(): void {}

  public afterMoveIntoPosition(): void {}

  public beforeCaptureFire(): void {}

  public triggerCaptureFire(): void {
    app.audioHandler.playSound(this.scene, Sounds.Track.BuffCrane1, Sounds.Channel.SFX, { volume: 1.0 });
    this.vehicle.CharacterSpine.fireEquipment();
  }

  public beforeCaptureHit(): void {
    app.audioHandler.playSound(this.scene, Sounds.Track.SnowyCranePickup1, Sounds.Channel.SFX, { volume: 1.0 });
  }

  public onCaptureHit(): void {}

  public onPull(): void {
    app.audioHandler.playSound(this.scene, this.vehicle.sounds.cheer, Sounds.Channel.SFX, { volume: 1.0 });
    this.vehicle.CharacterSpine.heroPull();
  }

  protected animationEvent(entry: spine.TrackEntry, event: spine.Event) {
    if (event.stringValue == VehicleCaptureCrane.animationEvents.StartCrane) this.vehicle.VehicleManager.VillainVehicle?.startLift();
    else if (event.stringValue == VehicleCaptureCrane.animationEvents.StopCrane) this.vehicle.VehicleManager.VillainVehicle?.stopLift();

    console.log(entry.animation, event.stringValue);
  }

  protected cleanUp() {
    this.vehicle.CharacterSpine.off(SpineEvents.Event, this.animationEvent, this);
  }
}
